import "./form-transaction-addon.scss";
import { useFormContext } from "react-hook-form";
import { TransactionAddonFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { LabelValue } from "@shared/models/label-value.interface";
import { GetItemDto } from "@api/api";
import { useEffect, useState } from "react";
import { GetResponseItemModel } from "@factory/model/query-model-item";
import { useQyGetItem } from "@factory/query/item.query";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";

type InputFormSchema = TransactionAddonFormSchema;
export function FormTransactionAddon() {
  const { control, setValue, watch } =
    useFormContext<TransactionAddonFormSchema>();
  const [addonList, setAddonList] = useState<LabelValue[]>([]);
  const [addonData, setAddonData] = useState<GetItemDto[]>([]);
  const addonId = watch("item");
  const quantity = watch("quantity");

  const handleServiceSuccess = (data: GetResponseItemModel) => {
    if (!data || data.data?.length === 0) {
      return;
    }

    const responseData = data.data || [];
    const labelValue = LabelValue.MapArray(
      responseData,
      (item) => item.name,
      (item) => item.code
    );
    setAddonData(responseData);
    setAddonList(labelValue);
  };
  useQyGetItem("", 9999, 0, undefined, undefined, true, handleServiceSuccess);

  useEffect(() => {
    if (!addonId || addonData.length === 0 || !quantity) return;

    const addon = addonData.filter((item) => item.code === addonId);
    const amount = addon[0].amount ?? 0;
    const totalAmount = amount * quantity;
    setValue("amount", totalAmount);
  }, [addonId, addonData, quantity]);

  return (
    <div id="FormTransactionAddon" className="transaction-addon">
      <DropdownControl<InputFormSchema>
        control={control}
        name="item"
        label="Item"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Select an item"
        options={addonList}
        onSelect={(item) => {
          const selectedItem = addonData.find((x) => (x.code === item));
          setValue("itemData", selectedItem);
        }}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="quantity"
        label="Quantity"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter quantity"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        disabled={true}
      />
    </div>
  );
}

export default FormTransactionAddon;
